/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GenerateTopicsDto } from '../models/GenerateTopicsDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TopicService {
    /**
     * List active topics + their suggested Posts (per topic).
     * @returns any
     * @throws ApiError
     */
    public static topicControllerListV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/topics',
        });
    }
    /**
     * Generate N more topic seeds (or a single replacement when replaceTopicId is set).
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static topicControllerGenerateV1(
        requestBody: GenerateTopicsDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/topics/generate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Dismiss every still-suggested topic in a batch (no per-topic replacement). Used when the user clears a directed-generation batch from the home switcher.
     * @param batchId
     * @returns any
     * @throws ApiError
     */
    public static topicControllerDismissBatchV1(
        batchId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/topics/batch/{batchId}/dismiss',
            path: {
                'batchId': batchId,
            },
        });
    }
    /**
     * Pick a topic; lazy-generates its 3 creatives if not present.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static topicControllerPickV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/topics/{id}/pick',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Generate N additional creative cards for a topic. Skewed shape distribution.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static topicControllerGenerateMoreV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/topics/{id}/generate-more',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Dismiss a topic; auto-fills a replacement.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static topicControllerDismissV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/topics/{id}/dismiss',
            path: {
                'id': id,
            },
        });
    }
}
